/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'react';
import { getFormatsBySport } from '../services/format';
import { listFormatActions } from './definition';


const formatListReset = () => {
    return {
        type: listFormatActions.LIST_FORMAT_RESET,
    };
};

// Recuders of Format Collection
function formatIsLoadingList() {
    return {
        type: listFormatActions.LIST_FORMAT_IS_LOADING,
    };
}

function formatErrorList(e: string) {
    return {
        type: listFormatActions.LIST_FORMAT_ERROR,
        error: e,
    };
}

function formatSetList(formats: any) {
    return {
        type: listFormatActions.LIST_FORMAT,
        data: formats,
    };
}

/**
 * Reducer to rest a formats
 * @param values Data to reset formats
 */
export const resetStateFormat = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(formatListReset());
    };
};



/**
 * Reducer to reset Formats
 * @param values Values to reset formats
 */
export const resetFormat = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(formatListReset());
    };
};

// List


/**
 * Reducer to get a format by id
 * @param id Id of format to find
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getFormatBysport = (query) => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(formatIsLoadingList());
        try {
            const response = await getFormatsBySport(query);
            /*if (response?.statusCode === 'FIELDS_FORMATS_LISTED' && response.data) {
                dispatch(formatSetList(response));
            } else {
                dispatch(formatErrorList('Could not get format: '));
            }*/
            dispatch(formatSetList(response));
        } catch (error: any) {
            dispatch(formatErrorList('No se pudo obtener el format'));
        }
    };
};
